import { useEffect, useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Zap } from "lucide-react";
import { useLeadModals } from "@/components/LeadModals";
import { OfferCountdown } from "@/components/home/OfferCountdown";

const STORAGE_KEY = "reh360_exit_popup_shown";

export const ExitIntentPopup = () => {
  const [open, setOpen] = useState(false);
  const { openTrial } = useLeadModals();

  useEffect(() => {
    if (sessionStorage.getItem(STORAGE_KEY)) return;
    let shown = false;
    let engaged = false;

    const show = () => {
      if (shown) return;
      shown = true;
      sessionStorage.setItem(STORAGE_KEY, "1");
      setOpen(true);
    };

    const onMouseOut = (e) => {
      if (e.clientY <= 0 && !e.relatedTarget) show();
    };
    const onScroll = () => {
      const depth = window.scrollY / Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      if (depth > 0.3) engaged = true;
    };
    // Mobile fallback: no mouse-leave on touch — trigger after 40s of engaged reading
    const fallback = setTimeout(() => {
      if (engaged) show();
    }, 40000);

    document.addEventListener("mouseout", onMouseOut);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      document.removeEventListener("mouseout", onMouseOut);
      window.removeEventListener("scroll", onScroll);
      clearTimeout(fallback);
    };
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="border-2 border-hero-black bg-white sm:rounded-md"
        data-testid="exit-intent-popup"
      >
        <div className="text-center">
          <span className="inline-flex rounded-md bg-hero-gold p-3 text-hero-black shadow-[3px_3px_0_#111111]">
            <Zap className="h-7 w-7" aria-hidden="true" />
          </span>
          <h2 className="mt-5 font-display text-3xl font-bold uppercase leading-[1.02] tracking-tight text-hero-black">
            Wait — your first month is 50% off
          </h2>
          <p className="mx-auto mt-3 max-w-sm text-base leading-relaxed text-hero-black/70">
            360° room tours, drone flights & promo clips — custom-made for your company,
            ready in 48 hours. $1,000 instead of $2,000 for month 1.
          </p>
          <div className="mt-5 flex justify-center">
            <OfferCountdown />
          </div>
          <button
            onClick={() => { setOpen(false); openTrial(); }}
            data-testid="exit-intent-cta"
            className="mt-6 w-full rounded-md bg-hero-gold px-8 py-4 font-display text-lg font-semibold uppercase tracking-wide text-hero-black shadow-[4px_4px_0_#111111] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[6px_6px_0_#111111]"
          >
            Claim 50% Off Month 1
          </button>
          <button
            onClick={() => setOpen(false)}
            data-testid="exit-intent-dismiss"
            className="mt-3 text-sm font-semibold text-hero-black/50 underline-offset-2 transition-colors hover:text-hero-black hover:underline"
          >
            No thanks, I'll pay full price later
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
